var _rect, _circle, _rect2, _rect3, _rect4, _rect5, _circle2, _rect6, _rect7, _rect8, _rect9, _circle3, _rect0, _rect1, _rect10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgGateSegmentsPlaceholder = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 173,
    height: 117,
    viewBox: "0 0 173 117",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 29.9499,
    y: 0.424479,
    width: 142.625,
    height: 33.9583,
    rx: 6.36719,
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 154.324,
    cy: 17.8285,
    r: 5.30599,
    fill: "white",
    stroke: "#0067b0",
    strokeWidth: 1.27344
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 37.166,
    y: 7.64062,
    width: 44.9948,
    height: 7.64062,
    rx: 3.39583,
    fill: "#EAEBED"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 37.166,
    y: 17.8281,
    width: 66.2188,
    height: 7.64062,
    rx: 3.39583,
    fill: "#F3F4F6"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 29.9499,
    y: 0.424479,
    width: 142.625,
    height: 33.9583,
    rx: 6.36719,
    stroke: "#E5E7EB",
    strokeWidth: 0.848958
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 20.9499,
    y: 82.4245,
    width: 142.625,
    height: 33.9583,
    rx: 6.36719,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 145.324,
    cy: 99.8285,
    r: 5.30599,
    fill: "white",
    stroke: "#0067b0",
    strokeWidth: 1.27344
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 28.166,
    y: 89.6406,
    width: 44.9948,
    height: 7.64062,
    rx: 3.39583,
    fill: "#EAEBED"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 28.166,
    y: 99.8281,
    width: 66.2188,
    height: 7.64062,
    rx: 3.39583,
    fill: "#F3F4F6"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 20.9499,
    y: 82.4245,
    width: 142.625,
    height: 33.9583,
    rx: 6.36719,
    stroke: "#E5E7EB",
    strokeWidth: 0.848958
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 0.424479,
    y: 41.1745,
    width: 142.625,
    height: 33.9583,
    rx: 6.36719,
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 124.796,
    cy: 58.5784,
    r: 5.30599,
    fill: "white",
    stroke: "#0067b0",
    strokeWidth: 1.27344
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 7.64062,
    y: 48.3906,
    width: 44.9948,
    height: 7.64062,
    rx: 3.39583,
    fill: "#EAEBED"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 7.64062,
    y: 58.5781,
    width: 66.2188,
    height: 7.64062,
    rx: 3.39583,
    fill: "#F3F4F6"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 0.424479,
    y: 41.1745,
    width: 142.625,
    height: 33.9583,
    rx: 6.36719,
    stroke: "#E5E7EB",
    strokeWidth: 0.848958
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgGateSegmentsPlaceholder);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/gate-segments-placeholder.6c3fc8a77c4b7d0c473ec1e593b13184.svg";